import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.css";

export default class extends Controller {
  static targets = ["select"]

  connect() {
    const hasSelection = this.selectTarget.selectedOptions.length > 0

    this.choices = new Choices(this.selectTarget, {
      removeItemButton: true,
      placeholder: !hasSelection,
      placeholderValue: this.selectTarget.dataset.placeholder || "Select...",
      noResultsText: "No results found",
      noChoicesText: "No choices available",
      itemSelectText: "",
    })

    this.selectTarget.addEventListener("change", () => {
      this.element.closest("form")?.requestSubmit()
    })
  }

  disconnect() {
    this.choices?.destroy()
  }
}
